import React from 'react';

import {
  animatedBaseBarClass,
  animatedFilteredBarClass,
  BarLabel,
  baseBarClass,
  ColorPaletteName,
  colorPalettes,
  filteredBarClass
} from '../../style/CountBarStyles';

export interface CountBarProps {
  readonly maxValue: number | null;
  readonly currentValue: number | null;
  readonly maxWidth?: number; // Defaults to "100%" width, which is overridable by a specified pixel width
  readonly height: number;
  readonly label?: string;
  readonly colorPaletteName?: ColorPaletteName;
  readonly shouldAnimateBarWidth: boolean;
}

export class CountBar extends React.Component<CountBarProps> {

  private getWidth() {
    if (this.props.maxValue && this.props.currentValue) {
      return `${100 * (this.props.currentValue / this.props.maxValue)}%`;
    }
    return 0;
  }

  public override render(): JSX.Element {
    const barSizeStyle: React.CSSProperties = {
      maxWidth: this.props.maxWidth,
      width: this.props.maxWidth,
      height: this.props.height,
      minWidth: this.props.currentValue && this.props.currentValue > 0 ? 2 : 0
    };
    return (
      <div className={this.props.colorPaletteName && colorPalettes[this.props.colorPaletteName]} style={{ borderRadius: 'inherit' }}>
        <div className={this.props.shouldAnimateBarWidth ? animatedBaseBarClass : baseBarClass} style={barSizeStyle}>
          <div
            className={this.props.shouldAnimateBarWidth ? animatedFilteredBarClass : filteredBarClass}
            style={{ ...barSizeStyle, width: this.getWidth() }}
          />
          {this.props.label ? <BarLabel style={{ lineHeight: `${this.props.height + 2}px` }}>{this.props.label}</BarLabel> : null}
        </div>
      </div>
    );
  }
}
